export default "__VITE_ASSET__U_1akhHg__"